exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.action[data-v-31d9a406]{margin-right:5px!important}div.card.backup[data-v-31d9a406]{width:230px;height:190px;margin:10px;padding:2px;display:inline-block;flex-direction:unset;cursor:pointer}", ""]);

// exports
